var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-or-pay-modal"},[(_vm.getDataStatus)?_c('div',[(_vm.user.userLevel)?_c('DredgeVipDefault',_vm._b({},'DredgeVipDefault',_vm.$attrs,false)):_c('LoginModule')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }